angular.module("admin").factory("UpdateService", ["$http", "ENV", function ($http, ENV) {

	var SERVER = "integ";
	var url = window.location.href;
	if (url.indexOf("integ.") > -1) {
		SERVER = "integ";
	} else if (url.indexOf("demo.") > -1) {
		SERVER = "demo";
	} else if (url.indexOf("iti.") > -1) {
		SERVER = "prod";
	}

	/**
	 * API
	 */
	return {
		checkToken: checkToken,
		getInformations: getInformations,
		postInformation: postInformation,
		clearInformation: clearInformation
	};

	function getInformations() {
		return $http.get(ENV.API_UPDATE_OKINA_APP + "infos?server=" + SERVER);
	}

	function clearInformation(token) {
		return $http.post(ENV.API_UPDATE_OKINA_APP + "infos/clear?server=" + SERVER, {
			token : token
		});
	}

	function checkToken(token) {
		return $http.post(ENV.API_UPDATE_OKINA_APP + "token", {
			token : token
		});
	}

	function postInformation(info, token) {
		info["token"] = token;
		return $http.post(ENV.API_UPDATE_OKINA_APP + "infos?server=" + SERVER, info);
	}

}]);
